import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GIFTING_CONTENT as FALLBACK_GIFTING, WHATSAPP_NUMBER } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const GIFTING_WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi House of Seya! I'd like some help picking a gift.")}`;

const Gifting = () => {
  const pageData = null;

  const hero = pageData?.hero || FALLBACK_GIFTING.hero;
  const categories = pageData?.categories || FALLBACK_GIFTING.categories;
  const readyToShip = pageData?.readyToShip || FALLBACK_GIFTING.readyToShip;
  const faqs = pageData?.faqs || FALLBACK_GIFTING.faqs;

  return (
    <main className="bg-[#FFFFFF]">
      {/* Hero */}
      <div className="relative w-full h-[100dvh] min-h-[420px] lg:h-[86vh] hero-vh-lg-86 overflow-hidden">
        <img src={hero.image} alt={hero.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
          <div className="text-center text-white px-6">
            <div className="text-[11px] tracking-widest-2 uppercase mb-3">{hero.tagline}</div>
            <h1 className="font-serif text-4xl lg:text-6xl">{hero.title}</h1>
          </div>
        </div>
      </div>

      {/* Categories */}
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-24">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 lg:gap-8">
          {categories.map((c, i) => (
            <div key={c.title || i} className="group">
              <div className="aspect-[4/5] overflow-hidden bg-[#FFFFFF]">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
              </div>
              <div className="mt-5 text-center">
                <div className="font-serif text-2xl text-[#1a1a1a]">{c.title}</div>
                <p className="mt-2 text-sm text-[#5a5346] leading-relaxed">{c.body}</p>
                {c.href ? (
                  <Link to={c.href} className="mt-4 inline-block text-[11px] tracking-widest-2 uppercase text-[#999959] hover-underline">
                    Explore Curation
                  </Link>
                ) : (
                  <a href={GIFTING_WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="mt-4 inline-block text-[11px] tracking-widest-2 uppercase text-[#999959] hover-underline">
                    Get in Touch
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Ready to Ship */}
      <div className="bg-[#f7f4ee] py-16 text-center px-6">
        <h2 className="font-serif text-2xl lg:text-3xl text-[#1a1a1a]">{readyToShip.title}</h2>
        <p className="mt-3 text-sm text-[#5a5346] max-w-lg mx-auto leading-relaxed">{readyToShip.body}</p>
        <a
          href={GIFTING_WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta mt-6 inline-block"
        >
          Message Now
        </a>
      </div>

      {/* FAQ */}
      <div className="max-w-[800px] mx-auto px-6 lg:px-10 pt-20 lg:pt-28 pb-24 lg:pb-32">
        <div className="text-center mb-10">
          <h2 className="font-serif text-2xl lg:text-3xl text-[#1a1a1a]">Frequently Asked Questions</h2>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#d8ceb9]">
              <AccordionTrigger className="font-serif text-base lg:text-lg text-[#1a1a1a] py-5 hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-[14px] text-[#5a5346] leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>

      {/* CTA */}
      <div className="bg-[var(--brand-sage)] text-[#FFFFFF] py-20 lg:py-24 text-center px-6">
        <h2 className="font-serif text-3xl lg:text-4xl">Still deciding?</h2>
        <p className="mt-4 text-[#EDE9D6] max-w-md mx-auto">
          Message us on WhatsApp and we'll help you find the right piece — usually within the hour.
        </p>
        <a
          href={GIFTING_WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-block text-[11px] tracking-widest-2 uppercase border-b border-[#F4EFD8] pb-1 text-[#F4EFD8] hover:text-white"
        >
          Message Us
        </a>
      </div>
    </main>
  );
};

export default Gifting;
